import { render } from "./OutletSpreading.vue?vue&type=template&id=d6978f36"
import script from "./OutletSpreading.vue?vue&type=script&lang=js"
export * from "./OutletSpreading.vue?vue&type=script&lang=js"

import "./OutletSpreading.vue?vue&type=style&index=0&id=d6978f36&lang=css"

import exportComponent from "C:\\Users\\msimi\\Downloads\\tuaszone\\survey-agel-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__